// 深度代理
export const deepProxy = <T extends object>(obj, handler: ProxyHandler<T>) => {
  if (typeof obj === 'object' && obj !== null) {
    for (const key in obj) {
      obj[key] = deepProxy(obj[key], handler);
    }
    return new Proxy(obj, handler);
  } else {
    return <T>obj;
  }
};
